export enum Experiments {
  SHOW_LAST_NEXT_CHARGE = 'specs.subscriptionsTpa.ShowLastNextCharge',
  EXPOSE_NEW_FEATURE = 'specs.premium.subscriptions-tpa.exposeNewFeature',
  FIX_PRICE_CALCULATION_FOR_SUBSCRIPTION = 'specs.premium.subscriptions-tpa.FixPriceCalculationForSubscription',
  VERIFY_GRACE_PERIOD_BEFORE_PAY_NOW = 'specs.premium.subscriptions-tpa.VerifyGracePeriodBeforePayNow',
}
